import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router";
import { Box } from "@mui/material";
import moment from "moment";
import LmsKitLabel from "../../components/features/LmsKitLabel";
import ProgressTracker from "../../components/common/ProgressTracker";
import SkeletonLoader from "../../../utilites/SkeltonLoader";
import { getPatientDetailsById } from "../../slices/QRCode";
import { setSlugs } from "../../slices/help";
import { hasAuthority } from "../../../utils/authorities";
import { fetchV2V, selectAllInitialSteps, selectCurrentCycle,storePatientData } from "../../slices/common";
import MarkAsShippedForm from "../../components/common/ProgressTracker/MarkAsShippedForm";
import { recieveLSM } from "../../slices/logisticSlice";
import ChatModule from "../Chat";
import { addPatientList, addPhaseList } from "../../slices/chat";
import COAForm from "../../components/features/CoaForm";
import BreadCrumb from "../../../pages/breadcrumb/BreadCrumb"
import { urlToBackWithoutState } from "../../../utilites/Common";
import PublishProductModel from "../../components/features/PublishProductModel";
import {capitalizeWords} from "../../../utils/utils"
const QualityControlView1 = () => {
    const [loading] = React.useState(false);
    const { id } = useParams();
    const [publishModalOpen, setPublishModalOpen] = useState(false);

    const currentCycle = useSelector(selectCurrentCycle)
    const location = useLocation()
    const breadCrumbArray = useState(
        urlToBackWithoutState(location.pathname, location?.state)
    );
    const dispatch = useDispatch();
    const [patientInfo, setPatientInfo] = useState({});
    const [patientData, setPatientData] = useState({});
    const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
    const allInitialSteps = useSelector(selectAllInitialSteps)
    const [timeLineSkeletonLoading, setTimeLineSkeletonLoading] = useState(false);
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const [ids, setIds] = useState(id)
    const canShowCOA = allInitialSteps?.find(op => op.slug == "product-manufactured")?.status == 2
    const fetchPatientInfo = async (id = currentCycle?.qr_code_generation_id) => {
        try {
             if(!id) return
            const patientDetailsResponse = await dispatch(
                getPatientDetailsById({id:id,prodmfg:currentCycle?.product_manufacturing_id})
            ).unwrap();
            dispatch(storePatientData(patientDetailsResponse))
            const patientDetails = patientDetailsResponse?.data?.patient_information;
            const isBagCount = patientDetailsResponse?.data?.number_of_bags;
            if (patientDetails) {
                const patientBasicInfo = {
                    patientName: patientDetails?.name || "-",
                    patientId: patientDetails?.patient_id || "-",
                    id: patientDetails?.id,
                    product_id:patientDetailsResponse?.data?.product_id,
                    phase_id:patientDetails?.phase_id,
                      hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
                    inbond_form_id: patientDetails?.inbound_patient_id ?? null,
                    logisticOperationId: patientDetailsResponse?.data?.logistics_operation_id ?? null,
                    immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
                };
                const patientMedicalRecord = {
                    "Patient Body Weight": `${patientDetails?.body_weight} Kg` || "-",
                    "Disease Indication": capitalizeWords(patientDetails?.disease) || "-",
                    "Date of Birth": patientDetails?.dob
                        ? moment(patientDetails.dob).format("DD/MM/YYYY")
                        : "-",
                    "Hospital Name": patientDetails?.hospital || "-",
                    "Hospital Patient ID": patientDetailsResponse?.data?.hospital_patient_id || "-",
                    "Ship & Store": "2-8 degree celsius",
                    "Total no Bags": isBagCount ?? 0,
                    "Batch ID": patientDetailsResponse?.data?.batch_no || "-",
                };
                setPatientData(patientDetailsResponse?.data)
                setPatientInfo(patientBasicInfo);
                setPatientMedicalInfo(patientMedicalRecord);
            }
        } catch (error) {
            console.error("Error fetching patient info:", error);
        }
    };


    // function to get the timeline
    const getTimeLine = async (id) => {
        setTimeLineSkeletonLoading(true)
        try {
            await dispatch(
                fetchV2V({ portal_type: 2, patient_id: id ?? patientInfo?.id })
            ).unwrap();
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setTimeLineSkeletonLoading(false)
        }
    };

    // function to mark lsm as recieved
    const handleRecieveLSM = async (step) => {
        try {
            if (step.slug == "qc-testing") {
                setPublishModalOpen(true)
            } else {
                const res = await dispatch(
                    recieveLSM({ id: patientInfo?.logisticOperationId })
                ).unwrap();
                if (res?.status == 200) {
                    getTimeLine();
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    }

    // function to handle when LSM is marked shipped
    const handleLSMMarkedShipped = () => {
        getTimeLine();
        fetchPatientInfo();
    }

    useEffect(() => {
      if(ids){
    fetchPatientInfo(ids);
    setIds('')
      }
  }, [ids]);
  
  useEffect(() => {
    if(!ids)
      fetchPatientInfo()
  },[currentCycle?.product_manufacturing_id])

    // Get Timeline when component mounts
    useEffect(() => {
        const patientId = patientInfo?.id
        if (patientId)
            getTimeLine(patientId)
    }, [patientInfo])

    useEffect(() => {
        if (
            hasAuthority(
                ["in-bound-marked-shipped", "in-bound-marked-received"],
                bmr_permissions
            )
        ) {
            dispatch(setSlugs(["lsm-shipped", "lsm-received"]));
        }
        return () => {
            dispatch(setSlugs([""]));
        };
    }, []);
    ////////// phase and pantient List for chat bot ///////////

    useEffect(() => {
        const phaseList = [{ value: patientData?.patient_information?.phase_id, label: `${patientData?.phase_name} (${patientData?.product_name})`, patient_id: patientData?.patient_information?.id }]
        const patientList = [{ value: patientData?.patient_information?.id, label: `${patientData?.patient_information?.name}`, phase_id: patientData?.patient_information?.phase_id }]
        dispatch(addPatientList(patientList))
        dispatch(addPhaseList(phaseList))
    }, [patientData])

    ////////////////////////////////////////////////////////////

    return (
        <Box>
            <Box container className="mt-4 ml-3 mr-3 mainDiv">
                <BreadCrumb BreadCrumbsListing={breadCrumbArray} />
                <LmsKitLabel
                    screenType="logistics"
                    patientInfo={patientInfo}
                    patientMedicalInfo={patientMedicalInfo}
                    qrCodeId={id}
                />
            </Box>

            <Box container className="mt-4 ml-3 mr-3 pb-3 mainDiv">
                {timeLineSkeletonLoading ? (
                    <SkeletonLoader rowCount={1} height={80} isTable={false} />
                ) : <ProgressTracker
                    FormComponent={MarkAsShippedForm}
                    steps={allInitialSteps}
                    patient_id={patientData?.patient_information?.id}
                    onAction={handleRecieveLSM}
                    onUpdate={handleLSMMarkedShipped} />
                }
            </Box>
            {canShowCOA &&
                <Box className="mt-4 ml-3 mr-3 pb-3">
                    {loading ? (
                        <SkeletonLoader rowCount={1} height={80} isTable={false} />
                    ) : (
                        <COAForm
                            patientData={
                                {
                                    ...patientInfo,
                                    ...patientData,
                                    qrCode_id:  currentCycle?.qr_code_generation_id,
                                    feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
                                    inbond_form_id: currentCycle?.inbond_patients_id,
                                    patient_id: patientData?.patient_information?.id
                                }}
                            fetchPatientInfo={fetchPatientInfo}
                            initialSteps={allInitialSteps}
                            updateTimeLine={getTimeLine}
                        />
                    )}
                </Box>}
            <PublishProductModel
                publishModalOpen={publishModalOpen}
                setPublishModalOpen={setPublishModalOpen}
                getTimeLine={getTimeLine}
                data={{ ...patientData, qrCode_id: currentCycle?.qr_code_generation_id }}
            />
            <ChatModule />
        </Box>
    );
};

export default QualityControlView1;
